'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$() {
  this.aV1 = null;
  this.aV2 = false;
}
export { $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ as $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ };
$p = $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$;
/** @constructor */
function $h_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$() {
}
export { $h_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ as $h_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ };
$h_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$.prototype = $p;
$p.kw = (function() {
  if ((!this.aV2)) {
    this.aV1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBoolean$$anon$2(this);
    this.aV2 = true;
  }
  return this.aV1;
});
var $d_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$, "app.data.organization_types$package$OrganizationVerified$", ({
  GS: 1,
  B: 1,
  C: 1,
  oJ: 1
}));
export { $d_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ as $d_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ };
var $n_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$;
function $m_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$() {
  if ((!$n_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$)) {
    $n_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ = new $c_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$();
  }
  return $n_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$;
}
export { $m_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ as $m_Lapp_data_organization\uff3ftypes$package$OrganizationVerified$ };
//# sourceMappingURL=app.data.organization_types$package$-Organization-Verified$.js.map
